import { render, staticRenderFns } from "./RealNameAuthItem.vue?vue&type=template&id=5e0370e7&scoped=true"
import script from "./RealNameAuthItem.vue?vue&type=script&lang=js"
export * from "./RealNameAuthItem.vue?vue&type=script&lang=js"
import style0 from "./RealNameAuthItem.vue?vue&type=style&index=0&id=5e0370e7&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0370e7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e0370e7')) {
      api.createRecord('5e0370e7', component.options)
    } else {
      api.reload('5e0370e7', component.options)
    }
    module.hot.accept("./RealNameAuthItem.vue?vue&type=template&id=5e0370e7&scoped=true", function () {
      api.rerender('5e0370e7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/applet/setting/skinSetting/components/RealNameAuthItem.vue"
export default component.exports